// extracted by extract-css-chunks-webpack-plugin
module.exports = {"socialShare":"_1w-pvh aLs3Nr","icon":"_3vIrgo","ready":"B8qydi","shareHeading":"_39jscJ"};